/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Context_Menu_Auto_Time_CpsInputs */



/**
* | output |
* | --- |
* | "Calculate Timing by CPS" |
*
* @param {Context_Menu_Auto_Time_CpsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const context_menu_auto_time_cps = /** @type {((inputs?: Context_Menu_Auto_Time_CpsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Context_Menu_Auto_Time_CpsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Calculer le minutage par CPS")
	if (locale === "de") return /** @type {LocalizedString} */ ("Timingberechnung mit CPS")
	if (locale === "it") return /** @type {LocalizedString} */ ("Calcola i tempi tramite CPS")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Расчет времени выполнения по CPS")
	if (locale === "es") return /** @type {LocalizedString} */ ("Calcular tiempo por CPS")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("按CPS计算时间")
	if (locale === "ja") return /** @type {LocalizedString} */ ("CPSによるタイミングの計算")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सीपीएस द्वारा समय की गणना करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Calcular o tempo pelo CPS")
	return /** @type {LocalizedString} */ ("Calculate Timing by CPS")
});